module.exports = __webpack_public_path__ + "static/media/about-2.fa3ae74a.jpeg";